import React from "react";
import first1 from "../../assets/images/payment-methods-icon/credit-icon.svg";
import first2 from "../../assets/images/payment-methods-icon/credit-icon.svg";
import first3 from "../../assets/images/payment-methods-icon/credit-icon.svg";
import first4 from "../../assets/images/payment-methods-icon/credit-icon.svg";
import first5 from "../../assets/images/payment-methods-icon/credit-icon.svg";
import Main from "../../components/layout/Main";

function HelpCenterIndex() {
  return (
    <>
    <Main>
      <section>
        <div className="active-main-div">
          <div className="active-heading-div">
            <h1>Help Center</h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor.
            </p>
          </div>
          <div className="help-main-div">
            <div className="first-help-main-div">
              {" "}
              <div className="help-first-div">
                <div className="img-help-div">
                  <img src={first1} alt="img" />
                </div>
                <div className="text-help-sec">
                  <p>Account & Billing</p>
                </div>
              </div>{" "}
              <div className="help-first-div">
                <div className="img-help-div">
                  <img src={first2} alt="img" />
                </div>
                <div className="text-help-sec">
                  <p>Auctions & Bidding</p>
                </div>
              </div>{" "}
              <div className="help-first-div">
                <div className="img-help-div">
                  <img src={first3} alt="img" />
                </div>
                <div className="text-help-sec">
                  <p>Podcasts & Media</p>
                </div>
              </div>{" "}
              <div className="help-first-div">
                <div className="img-help-div">
                  <img src={first4} alt="img" />
                </div>
                <div className="text-help-sec">
                  <p>Privacy & Security</p>
                </div>
              </div>{" "}
              <div className="help-first-div">
                <div className="img-help-div">
                  <img src={first5} alt="img" />
                </div>
                <div className="text-help-sec">
                  <p>Community Guidelines</p>
                </div>
              </div>{" "}
            </div>

            <div className="help-sec-div">
              <div className="popular-main-div">
                <h1>Popular Articles</h1>
              </div>
              <div className="populer-text-div">
                <h1>How to place your first bid?</h1>
                <h2>Last updated: May 1, 2025</h2>
              </div>{" "}
              <div className="populer-text-div">
                <h1>Understanding subscription plans</h1>
                <h2>Last updated: Apr 28, 2025</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      </Main>
    </>
  );
}

export default HelpCenterIndex;
